import type { Theme } from '@mui/material';

export const muiAlertTitleOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
				fontWeight: theme.typography.fontWeightBold,
				marginBottom: '0',
				lineHeight: 'normal',
			};
		},
	},
};
